import {ChangeDetectionStrategy, Component, computed, effect, input, signal} from '@angular/core';
import {FormControl} from "@angular/forms";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'form-checkbox',
  standalone: true,
    imports: [ NgOptimizedImage ],
  templateUrl: './form-checkbox.component.html',
  styleUrl: './form-checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormCheckboxComponent {
    inputControl = input.required<FormControl<boolean>>();
    disabled = input(false);

    private value = signal(false);
    isChecked = computed(() => this.value());

    constructor() {
        effect((onCleanup) => {
            const control = this.inputControl();
            this.value.set(control.value);
            const sub = control.valueChanges.subscribe(value => this.value.set(value));
            onCleanup(() => sub.unsubscribe());
        }, { allowSignalWrites: true });
    }

    toggle() {
        if (!this.disabled()) {
            this.inputControl().setValue(!this.inputControl().value);
        }
    }
}
